import { createSlice } from "@reduxjs/toolkit";
import { Loading, UserFailure, UserRepository } from "../domain";
import { AppThunk } from "./store";
import { Services, ServiceLocater } from "../service-locater";

type LoginAuthState = {
  loading: Loading;
  loadingType: "login-with-password" | "forgot-password" | "login-with-code";
  password: string;
  failure?: UserFailure;
};

const initialState: LoginAuthState = {
  loading: "idle",
  loadingType: "login-with-password",
  password: "",
};

const loginAuthSlice = createSlice({
  name: "loginAuth",
  initialState,
  reducers: {
    setPassword(state, action) {
      state.failure = undefined;
      state.password = action.payload;
    },
    loading(state, { payload }) {
      state.failure = undefined;
      state.loadingType = payload;
      state.loading = "pending";
    },
    failure(state, action) {
      state.failure = action.payload;
      state.loading = "failed";
    },
    success(state) {
      state.failure = undefined;
      state.loading = "succeeded";
    },
    resetLoginAuth(state) {
      state.loading = initialState.loading;
      state.loadingType = initialState.loadingType;
      state.password = initialState.password;
    },
  },
});

export const { setPassword, resetLoginAuth } = loginAuthSlice.actions;
export default loginAuthSlice.reducer;

const { loading, failure, success } = loginAuthSlice.actions;

export const loginWithPassword = (phone: string): AppThunk => async (
  dispatch,
  getState
) => {
  dispatch(loading("login-with-password"));
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).loginWithPassword(phone, getState().loginAth.password);
  res.fold(
    (l) => dispatch(failure(l)),
    (_) => dispatch(success())
  );
};

export const loginWithCode = (phone: string): AppThunk => async (dispatch) => {
  dispatch(loading("login-with-code"));
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).loginWithCode(phone);
  res.fold(
    (l) => dispatch(failure(l)),
    (_) => dispatch(success())
  );
};

export const forgotPassword = (phone: string): AppThunk => async (dispatch) => {
  dispatch(loading("forgot-password"));
  const res = await ServiceLocater.get<UserRepository>(
    Services.UserRepository
  ).forgotPassword(phone);
  res.fold(
    (l) => dispatch(failure(l)),
    (_) => dispatch(success())
  );
};
